import(/* webpackMode: "eager" */ "/home/runner/work/apollo/apollo/apps/healthcare.com/src/app/partner-news/error.tsx");
